import React, { useMemo } from "react";
import ProduitCard from "../../composantFouta/ProduitCard";
import { useGetProductListQuery } from "../../../utils/api/product/product.api";
import { Product } from "../../../utils/api/product/product.type";
import { ProductItemsSkeleton } from "./ParcoursAchat";
import { AlertInfo } from "../../common/Alert";

const SIMILAR_LIMIT = 24;
const SIMILAR_DISPLAY = 12;

function ProductSimilary({ product }: { product: Product }) {
  const categorySlug =
    typeof product?.categorie === "object"
      ? product?.categorie?.slug
      : undefined;
  const subCategorySlug =
    typeof product?.sous_categorie === "object"
      ? product?.sous_categorie?.slug
      : undefined;

  // Filtrer par catégorie uniquement (pas la sous-catégorie) :
  // sinon « Nos produits » n'affiche souvent rien s'il n'y a pas d'autre article
  // dans la même sous-catégorie, alors que « Services » en a davantage.
  const { data, isLoading } = useGetProductListQuery(
    {
      categorie: categorySlug || "",
      limit: SIMILAR_LIMIT,
    },
    { skip: !categorySlug },
  );

  const similar = useMemo(() => {
    const results = data?.results ?? [];
    const others = results.filter((el) => el?.id !== product?.id);

    if (!subCategorySlug) {
      return others.slice(0, SIMILAR_DISPLAY);
    }

    const sameSub = others.filter(
      (el) =>
        typeof el?.sous_categorie === "object" &&
        el?.sous_categorie?.slug === subCategorySlug,
    );
    const otherSub = others.filter(
      (el) =>
        !(
          typeof el?.sous_categorie === "object" &&
          el?.sous_categorie?.slug === subCategorySlug
        ),
    );

    return [...sameSub, ...otherSub].slice(0, SIMILAR_DISPLAY);
  }, [data?.results, product?.id, subCategorySlug]);

  if (!categorySlug) {
    return null;
  }

  return (
    <div className="container-produits-similaires mb-5">
      <h3 className="title-produits-similaires">Produits similaires</h3>

      {isLoading && (
        <div className="fb-produits-grid py-4">
          <ProductItemsSkeleton />
        </div>
      )}

      {!isLoading && similar.length > 0 && (
        <div className="fb-produits-grid py-4">
          {similar.map((produit) => (
            <ProduitCard key={produit.id ?? produit.slug} item={produit} />
          ))}
        </div>
      )}

      {!isLoading && similar.length === 0 && (
        <div className="py-4 d-flex justify-content-center">
          <AlertInfo message="Aucun produit similaire disponible pour le moment" />
        </div>
      )}
    </div>
  );
}

export default ProductSimilary;
